<template>
  <div id="Login">
    <v-layout>
      <v-flex xs12 sm6 offset-sm3 class="mt-2">
        <v-card>
          <v-flex style="text-align: center;">
            <img alt="UB Logo" src="/static/logo_ub2.png" height="85px" style="margin-top: 5%" contain />
            <img alt="UCM Logo" src="/static/logo_ucm.jpg" height="85px" contain />
          </v-flex>
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">{{ $t('login.TITLE') }}</h3>
              <span class="grey--text">{{ $t('login.SUBTITLE') }}</span>
            </div>
          </v-card-title>
          <v-flex xs10 sm6 offset-sm3 offset-xs1 v-if="errorLogin">
            <p class="red--text"> {{ $t('login.errorLogin.MESSAGE') }} </p>
          </v-flex>
          <v-flex xs10 offset-xs1 sm6 offset-sm3 v-show="loading" class="text-align-center">
            <v-progress-circular v-bind:size="50" indeterminate class="primary--text"></v-progress-circular>
          </v-flex>
          <v-flex xs10 sm6 offset-sm3 offset-xs1 v-show="!loading">
            <v-text-field
              name="email"
              :label="$t('forms.EMAIL')"
              type="email"
              id="email"
              v-model="user"
            ></v-text-field>
          </v-flex>
          <v-flex xs10 sm6 offset-sm3 offset-xs1 v-show="!loading">
            <v-text-field
              name="password"
              :label="$t('forms.ENTER_PASSWORD')"
              hint=""
              v-model="password"
              :append-icon="e1 ? 'visibility' : 'visibility_off'"
              :append-icon-cb="() => (e1 = !e1)"
              :type="e1 ? 'password' : 'text'"
            ></v-text-field>
          </v-flex>
          <v-card-actions>
            <v-btn flat class="text" @click.native.stop="dialogLostPassword = true">
              {{ $t('login.ACTION_LOST_PASSWORD') }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn flat class="green--text" @keyup.enter.native="submit" @click.native="submit()">
              {{ $t('login.ACTION_ENTER') }}
            </v-btn>
          </v-card-actions>
        </v-card>
        <p class="body-2 text-xs-center mt-4" v-html="$t('login.FOOTER_PROJECT')"></p>
        <p class="body-1 text-xs-center">{{ $t('login.FOOTER_IP') }}</p>
        <p class="caption text-xs-center">{{ $t('login.FOOTER_COPYRIGHT') }} ({{ currentYear }})</p>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialogLostPassword" persistent max-width="450">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('login.lostPassword.TITLE') }}</span>
          <span class="subheading">{{ $t('login.lostPassword.SUBTITLE') }}</span>
        </v-card-title>
        <v-card-text>
          <v-text-field :label="$t('forms.EMAIL')" v-model="forgotPasswordEmail" type="email" required autofocus :error-messages="$t(lostPasswordMessage)"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn class="darken-1" flat @click.native="dialogLostPassword = false">
            {{ $t('login.lostPassword.CANCEL') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click.native="sendForgotPasswordEmail">
            {{ $t('login.lostPassword.OK') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { TokenResource } from '../api/token'
export default {
  computed: {
    currentYear () {
      return new Date().getFullYear()
    }
  },
  name: 'login',
  data () {
    return {
      user: '',
      password: '',
      error: false,
      e1: true,
      dialogLostPassword: false,
      errorLogin: false,
      loading: false,
      forgotPasswordEmail: '',
      lostPasswordMessage: undefined
    }
  },
  mounted: function () {
    if (this.$auth.check()) this.$router.push('/home')
  },
  methods: {
    loginSuccess: function () {
      this.$router.replace(this.$route.query.redirect || '/')
    },
    loginError: function () {
      this.error = true
    },
    submit () {
      var credentials = {
        username: this.user,
        password: this.password
      }
      this.loading = true
      this.$auth.login({
        body: credentials,
        fetchUser: true,
        success () {
          this.loading = false
        },
        error (res) {
          this.errorLogin = true
          this.loading = false
        }
      })
    },
    sendForgotPasswordEmail () {
      TokenResource().forgotPassword(this.forgotPasswordEmail).then(_ => {
        this.lostPasswordMessage = undefined
        this.dialogLostPassword = false
      }, error => {
        if (error.status === 404) {
          this.lostPasswordMessage = 'login.lostPassword.NOT_FOUND'
        } else {
          this.lostPasswordMessage = 'login.lostPassword.ERROR'
        }
      })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Login.vue